import gql from 'graphql-tag';

import { lessonFragment } from '~/shared/graphql-queries/lessons/index';

export default gql`
  query findOneLessonQuery($filter: FilterFindOneLessonInput!) {
    findOneLessonQuery(filter: $filter) {
      ...LessonFragment
    }
  }
  ${lessonFragment}
`;
